import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import ColorBar from '../colorbar';
import style from './style.css';

class CustomThemeSection extends Component {
  constructor(props) {
    super(props);
  }

  render({ customBar, selected }) {
    return (
      <div>
        <div>
          <h6 className={`${style['select-color']} uppercase`}>
            Select color for different components of checkout page
          </h6>
          {customBar &&
            customBar.map(colorObj => {
              colorObj.CODE = selected.mobile[colorObj.KEY];
              return <ColorBar colorInfo={colorObj} />;
            })}
        </div>
      </div>
    );
  }
}

export default connect('customBar, selected')(CustomThemeSection);



// WEBPACK FOOTER //
// ./checkout/components/customtheme/index.js